<template>
    <div class="content-box first" style="overflow: visible" v-loading="dataLoading">
        <SongReleaseProgress style="position: absolute; top: -24px; left: 150px"></SongReleaseProgress>
        <el-form :model="formData" ref="formData" :rules="rules" label-position="top" :disabled="!isCanEdit">
            <el-row :gutter="60">
                <el-col :span="12">
                    <el-form-item label="歌曲源文件" prop="track.path" :rules="[{required: true, message: '请上传歌曲源文件', trigger: 'blur'}]">
                        <AudioUpload ref="audioUploadRef" :tarckData.sync="formData.track" @id3Update="id3Update" @onSuccess="handleAudioSuccess" @footer-state-change="onAudioFooterStateChange"></AudioUpload>
                    </el-form-item>
                    <div v-if="audioInlineNote" :class="['trackfile-inline-note', audioInlineNote.type]">
                        <i v-if="audioInlineNote.type === 'repairing'" class="el-icon-loading"></i>
                        <span :class="['repair-tag', audioInlineNote.type]">{{ audioInlineNote.tag }}</span>
                        <span>{{ audioInlineNote.text }}</span>
                    </div>
                    <el-form-item prop="lyrics" label="歌词">
                        <LrcFormat :lrc.sync="formData.lyrics" :lyrics-file-type.sync="lyricsFileType" :src="formData.track.path"></LrcFormat>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item prop="track.name" label="名称" :rules="[{required: true, message: '请输入名称'}]">
                        <el-input v-model="formData.track.name" placeholder="请输入名称" maxlength="250"></el-input>
                    </el-form-item>
                    <el-form-item prop="track.trackVersion" label="歌曲副标题">
                        <el-select v-model="formData.track.trackVersion" :clearable="true" placeholder="请选择歌曲版本">
                            <el-option v-for="(item, index) in trackVersionOptions" :key="index" :label="item" :value="item" />
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="track.langCode" label="表演语言" :rules="[{required: true, message: '请选择表演语言'}]">
                        <el-select v-model="formData.track.langCode" placeholder="请选择表演语言">
                            <el-option v-for="(item, index) in allLangCode" :key="index" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="track.genreId" label="流派/风格" :rules="[{required: true, message: '请选择风格流派'}]">
                        <el-cascader v-model="formData.track.genreId" :options="allGenre" :props="{emitPath: false}"></el-cascader>
                    </el-form-item>
                    <el-form-item prop="track.isAiGenerated" label="是否为AI生成">
                       <el-radio-group v-model="formData.track.isAiGenerated">
                            <el-radio :label="1" border>是</el-radio>
                            <el-radio :label="0" border>否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <ArtistSelectCard
                        :main-artist.sync="formData.mainArtist"
                        :other-artist.sync="formData.otherArtist"
                        :project-role-artist-info.sync="projectRoleArtistInfo"
                        :third-party-platform-stats.sync="thirdPartyPlatformStats"
                        :if-apple-verify="ifAppleVerify"
                        :is-album="false"
                        :display-lang-code="displayLangCode"
                        :disabled="!isCanEdit"
                    ></ArtistSelectCard>
                </el-col>
            </el-row>
            <el-form-item v-if="isCanEdit" class="submit-footer">
                <div class="footer-btns">
                    <el-button type="primary" @click="onSubmit" :loading="btnLoading" :disabled="isAudioSubmitDisabled">保存</el-button>
                </div>
                <div :class="['footer-note', audioFooterNote && audioFooterNote.type]">
                    {{ audioFooterNote && audioFooterNote.text }}
                </div>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import AudioUpload from '@/components/AudioUpload';
import ArtistSelectCard from '../components/ArtistSelectCard';
import {getLangCode, getGenre, fetchArtistType, checkAppleVerifyInfo} from '@/api/common';
import {uploadLyricByText} from '@/api/file';
import LrcFormat from '@/components/LrcFormat';
import SongReleaseProgress from '@/components/SongReleaseProgress';

export default {
    props: {
        albumId: {
            type: [Number, String],
            default: '',
        },
        trackId: {
            type: [Number, String],
            default: '',
        },
    },
    components: {AudioUpload, ArtistSelectCard, LrcFormat, SongReleaseProgress},
    data() {
        return {
            dataLoading: false,
            displayLangCode: '',
            formData: {
                track: {
                    explict: 0,
                    isAudition: 0,
                    isrcAuth: 1,
                    isAiGenerated: 0,
                },
                trackArtists: [],
                mainArtist: [],
                otherArtist: [
                    {type: 5, artist: []},
                    {type: 4, artist: []},
                ],
                lyrics: '',
            },
            lyricsFileType: 2,
            rules: {
                mainArtist: [{type: 'array', required: true, message: '至少添加一位艺人，主要的演唱艺人'}],
            },
            btnLoading: false,
            allLangCode: [],
            materiels: [],
            allGenre: [],
            status: 10,
            statusMsg: '',
            projectRoleArtistInfo: [],
            ifAppleVerify: false,
            isAudioSubmitDisabled: false,
            audioFooterNote: null,
            audioInlineNote: null,
            thirdPartyPlatformStats: []
        };
    },
    computed: {
        trackVersionOptions() {
            return ['现场', 'Demo', 'Remix', 'Remaster', '伴奏'];
        },
        isCanEdit() {
            return this.status === 10 || this.status === 13 || this.status === 14;
        },
    },
    created() {
        this.getAllLangCode();
        this.getAllGenre();
        this.getArtistType();
        if (this.albumId) this.getAlbumDisplayLangCode();
        if (this.trackId) {
            this.getDataDetail();
        }
    },
    beforeRouteLeave(to, from, next) {
        if (this.$refs.audioUploadRef) {
            this.$refs.audioUploadRef.cancel();
        }
        next();
    },
    methods: {
        onAudioFooterStateChange({submitDisabled, footerNote, inlineNote}) {
            this.isAudioSubmitDisabled = submitDisabled;
            this.audioFooterNote = footerNote;
            this.audioInlineNote = inlineNote;
        },
        goBack() {
            this.$router.go(-1);
        },
        getAllLangCode() {
            getLangCode().then((res) => {
                this.allLangCode = res;
            });
        },
        getAllGenre() {
            getGenre().then((res) => {
                this.allGenre = res;
            });
        },
        getAlbumDisplayLangCode() {
            this.$request({
                url: '/album/view/album_info',
                params: {albumId: this.albumId},
                method: 'post',
            }).then((res) => {
                const {state, result} = res.data;
                if (state == 1 && result && result.albumVo && result.albumVo.album) {
                    this.displayLangCode = result.albumVo.album.displayLangCode || '';
                }
            });
        },
        getDataDetail() {
            this.dataLoading = true;
            this.$request({
                url: '/album/view/track_info',
                params: {albumId: this.albumId, trackId: this.trackId},
                method: 'post',
            })
                .then((res) => {
                    const {state, msg, result} = res.data;
                    if (state == 1) {
                        const mainArtist = [];
                        const otherArtist = [];

                        (res.data.result.trackDtailVo.trackArtists || []).forEach((item) => {
                            const {artistId, artistName, type} = item;

                            switch (type) {
                                case 1:
                                    mainArtist.push({type, artistId, artistName});
                                    break;
                                default:
                                    {
                                        let o = otherArtist.find((item) => item.type === type);
                                        if (!o) {
                                            o = {type, artist: []};
                                            otherArtist.push(o);
                                        }

                                        o.artist.push({artistId, artistName});
                                    }
                                    break;
                            }
                        });

                        if (otherArtist.findIndex((row) => row.type === 5) === -1) {
                            otherArtist.push({type: 5, artist: []});
                        }
                        if (otherArtist.findIndex((row) => row.type === 4) === -1) {
                            otherArtist.push({type: 4, artist: []});
                        }

                        this.formData = {
                            ...this.formData,
                            ...result.albumVo.album,
                            albumId: parseInt(this.albumId),
                            lyrics: result.trackDtailVo.lyricsDetail,
                            track: {
                                ...result.trackDtailVo.track,
                            },
                            mainArtist: mainArtist,
                            otherArtist: otherArtist,
                        };
                        this.status = result.albumVo.album.status;
                        this.statusMsg = res.data.result.alertInfo;
                        this.thirdPartyPlatformStats = result.thirdPartyPlatformStats || [];
                        if (result.trackDtailVo.materiels && result.trackDtailVo.materiels.length > 0) this.materiels = result.trackDtailVo.materiels;
                    } else {
                        this.$message.error(msg || '获取数据失败,请重试');
                    }
                })
                .catch(() => {
                    this.$message.error('获取数据失败,请重试');
                })
                .finally(() => {
                    this.dataLoading = false;
                    this.checkAppleVerifyInfo();
                    this.isAudioSubmitDisabled = false;
                    this.audioFooterNote = null;
                    this.audioInlineNote = null;
                });
        },
        handleAudioSuccess() {
            if (this.formData.track.path) {
                this.$refs['formData'].clearValidate('track.path');
            }
        },
        artistChange() {
            let _artists = [...this.formData.mainArtist];
            this.formData.otherArtist.map((item) => {
                if (item.type) {
                    item.artist.map((v) => {
                        _artists.push({
                            ...v,
                            type: item.type,
                        });
                    });
                }
            });
            _artists.map((item, index) => {
                item.sort = index;
            });
            this.formData.trackArtists = [..._artists];
        },
        async id3Update(meta) {
            if (!this.formData.track.name && meta.name) {
                this.formData.track.name = meta.name;
            }
        },
        onSubmit() {
            this.artistChange();
            this.$refs['formData'].validate(async (valid) => {
                if (valid) {
                    this.btnLoading = true;
                    try {
                        if (this.formData.lyrics) {
                            try {
                                const response = await uploadLyricByText({
                                    lyricsDetail: this.formData.lyrics,
                                    lyricsFileType: this.lyricsFileType,
                                    id: this.materiels.length > 0 ? this.materiels[0].id : '',
                                });
                                const {state, msg} = response.data;
                                if(!state){
                                    this.$message.error(msg || '歌词上传失败，请重试');
                                }
                                const {fileName = '', url = ''} = response.data.result;
                                this.formData.materiels = [
                                    {
                                        materielName: fileName,
                                        materielPath: url,
                                        materielType: 7,
                                    },
                                ];
                            } catch(error){
                                this.$message.error(`歌词上传失败: ${error.message || '请重试'}`);
                            }
                        }
                        let _formData = {...this.formData};
                        delete _formData.otherArtist;
                        delete _formData.mainArtist;
                        const response = await this.$request({
                            url: '/album/up/save_track_info',
                            method: 'POST',
                            data: {
                                ..._formData,
                                albumId: this.albumId,
                            },
                            formData: false,
                        });
                        const {state, msg} = response.data;
                        if (state && state == 1) {
                            this.goBack();
                        } else {
                            throw new Error(msg || '操作失败');
                        }
                    } catch (error) {
                        this.$message.error(error.message || '保存失败，请重试');
                    } finally {
                        this.btnLoading = false;
                    }
                }
            });
        },
        async checkAppleVerifyInfo() {
            const res = await checkAppleVerifyInfo({cpId: this.formData?.cpId, verifyType: 100});
            const {state, msg, result} = res.data;
            if (!state) {
                return this.$message.error(msg);
            } else {
                if (result.ifAppleVerify == 1) {
                    this.ifAppleVerify = true;
                }
            }
        },
        async getArtistType() {
            try {
                const res = await fetchArtistType();
                const {state, result} = res.data;
                if (state && result) {
                    this.projectRoleArtistInfo = result.filter(item => item.classType == 2).map(item => ({label: item.name, value: item.value}));
                }
            } catch (error) {
                this.$message.error('获取艺人类型失败');
            }
        },
        hasProject(otherArtist, projectRoleArtist){
            const project = new Set(projectRoleArtist.map(item => item.value));
            for (const item of otherArtist) {
                if (Array.isArray(item.artist) && item.artist.length > 0) {
                    if (project.has(item.type)) {
                        return false;
                    }
                }
            }
            return true;
        }
    },
};
</script>

<style lang="scss" scoped>
.submit-footer {
    display: flex;
    align-items: center;
    padding: 0 20px;

    ::v-deep .el-form-item__content {
        display: flex;
        align-items: center;
        width: 100%;
    }
}

.footer-btns {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
}

.footer-note {
    font-size: 12px;
    line-height: 20px;
    margin-left: 16px;
    white-space: nowrap;

    &.warning {
        color: #e6a23c;
    }

    &.danger {
        color: #f56c6c;
    }
}

.trackfile-inline-note {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    line-height: 20px;
    margin-top: -18px;
    margin-bottom: 18px;
    padding-left: 0;

    .el-icon-loading {
        font-size: 14px;
    }

    &.repairing {
        color: #e6a23c;

        .el-icon-loading {
            color: #e6a23c;
        }
    }

    &.repaired {
        color: #606266;
    }

    &.failed {
        color: #f56c6c;
    }
}

.repair-tag {
    display: inline-block;
    padding: 1px 8px;
    border-radius: 10px;
    font-size: 12px;
    line-height: 18px;
    vertical-align: middle;
    margin-right: 2px;

    &.repaired {
        color: #175cd3;
        background: #eff8ff;
        border: 1px solid #b2ddff;
    }

    &.repairing {
        color: #b54708;
        background: #fffaeb;
        border: 1px solid #fedf89;
    }

    &.failed {
        color: #b42318;
        background: #fef3f2;
        border: 1px solid #fda29b;
    }
}
</style>
